import React from "react";

export default function SelectPlatform({ isOpen, onSelect }) {
    if (!isOpen) return null;

    const platforms = [
        { 
            label: "Facebook Videos", 
            platform: "facebook", 
            type: "videos", 
            bgColor: "#eff6ff", // Light blue
            textColor: "#1e40af",
            borderColor: "#bfdbfe",
            badgeBg: "#dbeafe",
            badgeText: "#1e40af"
        },
        { 
            label: "Facebook Photos", 
            platform: "facebook", 
            type: "photos", 
            bgColor: "#eff6ff", // Light blue
            textColor: "#1e40af",
            borderColor: "#bfdbfe",
            badgeBg: "#dbeafe",
            badgeText: "#1e40af"
        },
        { 
            label: "Instagram Photos/Videos", 
            platform: "instagram", 
            type: "videos", 
            bgColor: "#fdf2f8", // Light pink
            textColor: "#9d174d",
            borderColor: "#fbcfe8",
            badgeBg: "#fce7f3",
            badgeText: "#9d174d"
        },
    ];

    return (
        <div 
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(4px)" }}
        >
            <div className="bg-white dark:bg-slate-800 rounded-xl max-w-md w-full p-6 shadow-2xl text-center">
                <h2 className="text-xl font-bold mb-2 text-slate-800 dark:text-white">
                    Select Photos/Videos From
                </h2>
                <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
                    Choose from the options below to select photos/videos.
                </p>

                <div className="flex flex-col gap-3">
                    {platforms.map((item, index) => (
                        <button
                            key={index}
                            onClick={() => onSelect(item.platform, item.type)}
                            style={{
                                backgroundColor: item.bgColor,
                                color: item.textColor,
                                borderColor: item.borderColor,
                            }}
                            className="flex items-center justify-between w-full px-5 py-3 rounded-lg border transition-all duration-200 font-medium group hover:opacity-90"
                        >
                            <span>{item.label}</span>
                            <span 
                                style={{
                                    backgroundColor: item.badgeBg,
                                    color: item.badgeText
                                }}
                                className="text-xs px-2.5 py-1 rounded uppercase tracking-wider font-semibold"
                            >
                                {item.platform}
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}